/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TermsOfUseFileResponse
 */
export interface TermsOfUseFileResponse {
    /**
     * 
     * @type {string}
     * @memberof TermsOfUseFileResponse
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof TermsOfUseFileResponse
     */
    fileBase64: string;
}

/**
 * Check if a given object implements the TermsOfUseFileResponse interface.
 */
export function instanceOfTermsOfUseFileResponse(value: object): value is TermsOfUseFileResponse {
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('fileBase64' in value) || value['fileBase64'] === undefined) return false;
    return true;
}

export function TermsOfUseFileResponseFromJSON(json: any): TermsOfUseFileResponse {
    return TermsOfUseFileResponseFromJSONTyped(json, false);
}

export function TermsOfUseFileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TermsOfUseFileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'fileBase64': json['fileBase64'],
    };
}

export function TermsOfUseFileResponseToJSON(json: any): TermsOfUseFileResponse {
    return TermsOfUseFileResponseToJSONTyped(json, false);
}

export function TermsOfUseFileResponseToJSONTyped(value?: TermsOfUseFileResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileName': value['fileName'],
        'fileBase64': value['fileBase64'],
    };
}

